import { Box, Button } from '@mui/material';
import { Formik } from 'formik';
import { Flex } from 'src/components/Flex';
import { FileUploadSelect } from 'src/components/FormikComponents';
interface LogoUploadModalContentProps {
    handleEditModalClose: () => void;
    handleEdit: (logo: string) => void;
}

const LogoUploadModalContent = ({
    handleEditModalClose,
    handleEdit,
}: LogoUploadModalContentProps) => {
    return (
        <Box>
            <Formik
                initialValues={{
                    logo: '',
                }}
                onSubmit={(data) => {
                    handleEdit(data.logo);
                    handleEditModalClose();
                }}
            >
                {({ submitForm, values }) => {
                    return (
                        <Box>
                            <FileUploadSelect
                                name="logo"
                                label="Upload File"
                                maxFileSize={15000000}
                                landscapeImagesOnly
                                isNonSensitive={true}
                            />

                            <Flex justifyContent={'end'} pt={5} gap={2}>
                                <Button onClick={handleEditModalClose} variant="back-button">
                                    Cancel
                                </Button>
                                <Button
                                    type="submit"
                                    disabled={!values.logo}
                                    onClick={submitForm}
                                    variant="main"
                                >
                                    Save
                                </Button>
                            </Flex>
                        </Box>
                    );
                }}
            </Formik>
        </Box>
    );
};
export default LogoUploadModalContent;
